<template>
  <header>
    <!-- Patient details (name, email, phone, timestamps) -->
    <div class="detail">
      <h1>
        <!-- <PatientCall
          v-if="canCallPatient && getUserType !== 'observer'"
          :patient="patient"
          :provider-profile-list="canCallList"
        >
        </PatientCall> -->
        <p v-if="getUserType === 'observer'" style="padding-top: 16px;">
          {{ patient.aid }}
        </p>
        <span v-else>{{ patient.name }}</span>
        <el-tooltip
          v-if="isImported"
          effect="dark"
          content="EMR Import"
          placement="bottom">
          <ImportIcon v-if="isImported" style="margin-left: 8px;vertical-align: middle;"></ImportIcon>
        </el-tooltip>
      </h1>

      <div v-if="getUserType !== 'observer'" class="email">
        <span v-if="patient.phone"
          >{{ patient.phone
          }}<span class="weighted-middot"> &middot; </span></span
        >
        <el-tooltip
          v-if="!patient.verified && patient.email_bounce"
          effect="dark"
          content="Incorrect / Invalid email address"
          placement="bottom"
        >
          <span class="invalid">{{ patient.email }}</span>
        </el-tooltip>
        <span v-else>{{ patient.email }}</span>
      </div>

      <!-- Date of enrollment and last active date -->
      <div class="timestamp" v-if="patient.tag">
        <span v-for="tag in patient.tag" :key="tag.id">
          <template v-if="Array.isArray(tag.time)">
            <span v-for="time in tag.time" :key="time">
              <DeviceTagIcon :color="getTagColor(tag.id)"></DeviceTagIcon>
              {{ formatDate(time, false, true) }}
            </span>
          </template>
          <template v-else>
            <DeviceTagIcon :color="getTagColor(tag.id)"></DeviceTagIcon>
            {{ formatDate(tag.time, false, true) }}
          </template>
        </span>
      </div>
      <div class="timestamp" v-else>
        <template v-if="showProfile">
          <span style="font-size: 12px;">
            {{ getContentKey("profile", showProfile, "title") }}
            <span class="weighted-middot">&middot; </span>
          </span>
        </template>
        <router-link :to="'/patient/' + patient.id + '/account'"
          >Settings</router-link
        >
        <template v-if="patient.email && !patient.verified">
          <span class="weighted-middot"> &middot; </span>
          <a
            :class="resending ? 'resending' : ''"
            class="resend"
            @click="resendVerification"
          >
            Resend Confirmation
          </a>
          <div class="confirmationStatus">
            <p v-if="resending" class="icon-wrapper">
              <LoadSpinnerIcon type="primary"></LoadSpinnerIcon>
            </p>
            <p v-else-if="emailSentTimeout" class="sent">
              <i class="el-icon-check"></i>Email Sent
            </p>
            <p v-else-if="lastSent" class="lastSent">Last - {{ lastSent }}</p>
          </div>
        </template>
      </div>
    </div>

    <HeaderAction
      :routes="modifiedRoutes"
      :url="url + '/'"
      v-bind:count="count"
      :has-records="hasRecords"
      :has-flagged-problems="hasFlaggedProblems"
    ></HeaderAction>
  </header>
</template>

<script>
import Header from "@/module/component/header";
import PatientCall from "./PatientCall.vue";

import { mapActions, mapState, mapGetters } from "vuex";
import patientRoutes from "./routes";
import formatDate from "@/module/util/format-date";
import formatDateTime from "@/module/util/format-date-time";
import LoadSpinnerIcon from "@/module/component/icon/LoadSpinner";
import DeviceTagIcon from "@/module/component/DeviceTagIcon";
import ImportIcon from "./icon/Import"

export default {
  name: "provider-header",
  extends: Header,

  props: {
    patient: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      default: "/",
    },
  },

  data() {
    // Get the child routes of the provider module
    var routes = patientRoutes[0].children.filter((r) => !r.hidden);

    // Store the count for badges
    var count = {};
    routes.forEach((route) => {
      count[route.id] = 0;
    });

    return {
      routes,
      count,
      resending: false,
      resent: false,
      emailSentTimeout: false,
      lastSent: "",
    };
  },

  mounted() {
    this.lastSent = this.patient.last_verify_reminder
      ? this.getLastVarifyDate(this.patient.last_verify_reminder)
      : "";
  },

  methods: {
    formatDate,
    formatDateTime,
    ...mapActions("provider", ["resendVerify"]),
    resendVerification() {
      if (this.resending) return;

      this.resending = true;
      this.resendVerify({
        id: this.patient.id,
        provider: this.getCurrentProvider
          ? this.getCurrentProvider
          : this.providerProfileList[0].provider,
      })
        .then(() => {
          this.lastSent = this.getLastVarifyDate();
          this.resending = false;
          this.resent = true;
          this.emailSentTimeout = true;
          setTimeout(() => {
            this.emailSentTimeout = false;
          }, 3000);
        })
        .catch((error) => {
          console.log("resend error", error);
          this.resending = false;
        });
    },
    getLastVarifyDate(date) {
      if (date) return this.formatDateTime(new Date(date));
      return this.formatDateTime(new Date());
    },
    getTagColor(tag) {
      let tagObj = this.getTagToColorMapping.filter((obj) => obj.id === tag);
      if (tagObj.length) return tagObj[0].color;
      else return "#000000";
    },
  },

  computed: {
    ...mapState(["routeName"]),
    ...mapState("content", {
      profile: (state) => state.data.profile,
    }),
    ...mapGetters(["getUserType"]),
    ...mapGetters("content", ["getContentKey", "getContent"]),
    ...mapGetters("provider", [
      "getCurrentProvider",
      "getProvidersIdArray",
      "getPatientSurveys",
      "getTagToColorMapping",
    ]),
    providerProfileList() {
      try {
        let list = [];
        if (this.patient && this.patient.profile_map) {
          list = this.patient.profile_map
            .filter((profileProvider) => {
              if (this.getCurrentProvider)
                return profileProvider.includes(this.getCurrentProvider);
              else
                return this.getProvidersIdArray.some((providerId) =>
                  profileProvider.includes(providerId)
                );
            })
            .map((profileProvider) => ({
              profile: profileProvider.split(":")[1],
              provider: profileProvider.split(":")[0],
            }));
        } else if (this.patient && this.patient.profile)
          list = [
            {
              profile: this.patient.profile[0],
              provider: this.patient.providerId[0],
            },
          ];
        return list;
      } catch (error) {
        console.error("Problem getting providerProfileList", error);
        return [];
      }
    },
    hasRecords() {
      try {
        return this.providerProfileList.some(({ profile }) => {
          const profileObj = this.getContent("profile", profile);
          if (
            Array.isArray(profileObj.file_categories) &&
            profileObj.file_categories.length > 0
          )
            return true;
          if (
            Array.isArray(profileObj.record_categories) &&
            profileObj.record_categories.length > 0
          )
            return true;
          if (
            Array.isArray(profileObj.survey_questionnaire) &&
            profileObj.survey_questionnaire.length > 0
          )
            return true;
          return false;
        });
      } catch (error) {
        console.log(error);
        return true;
      }
    },
    hasFlaggedProblems() {
      return this.getPatientSurveys(this.patient.id).some((survey) => {
        if (survey.problem) {
          if (survey.problem.every((problem) => problem.resolved_time))
            return false;
          return true;
        }
        return false;
      });
    },
    isImported() {
      if(this.patient.athena || this.patient.ecw || this.patient.drchrono || this.patient.carecloud) 
        return true
      return false
    },
    showProfile() {
      try {
        if (this.providerProfileList && this.providerProfileList.length === 1)
          return this.providerProfileList[0].profile;
        else if (this.getCurrentProvider)
          return this.providerProfileList.find(
            ({ provider }) => provider === this.getCurrentProvider
          );
        return null;
      } catch (error) {
        console.error("Problem getting showProfile", error);
        return null;
      }
    },
    // canCallList() {
    //   try {
    //     // Checks whether patient, profile exists
    //     if (this.profile && this.patient) {
    //       return this.providerProfileList.filter((providerProfile) => {
    //         const profileObj = this.profile[providerProfile.profile];
    //         if (
    //           Array.isArray(profileObj.feature)
    //         ) {
    //           const featureArr = profileObj.feature.map((feature) =>
    //             typeof feature === "string" ? feature : feature.id
    //           );
    //           return featureArr.includes("telemedicine");
    //         }
    //         return false;
    //       });
    //     }
    //     return this.providerProfileList;
    //   } catch (error) {
    //     console.error("Problem calculating canCallPatient", error);
    //     return this.providerProfileList;
    //   }
    // },
    // /**
    //  * Calculates whether patient can be called
    //  * from provider
    //  * @returns {Boolean}
    //  */
    // canCallPatient() {
    //   try {
    //     // Checks whether patient, profile exists
    //     if (this.profile && this.patient) {
    //       //
    //       let profileList = this.providerProfileList.map(
    //         ({ profile }) => profile
    //       );


    //       return profileList.some((profileId) => {
    //         const profileObj = this.profile[profileId];
    //         if (
    //           Array.isArray(profileObj.feature)
    //         ) {
    //           const featureArr = profileObj.feature.map((feature) =>
    //             typeof feature === "string" ? feature : feature.id
    //           );
    //           return featureArr.includes("telemedicine");
    //         }
    //         return false;
    //       });
    //     }
    //     return false;
    //   } catch (error) {
    //     console.error("Problem calculating canCallPatient", error);
    //     return false;
    //   }
    // },
    modifiedRoutes() {
      if (this.getUserType === "observer") {
        this.routes[0].text = "Summary";
      }
      return this.routes;
    },
  },

  components: {
    PatientCall,
    LoadSpinnerIcon,
    DeviceTagIcon,
    ImportIcon
  },
};
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/header.scss";

a.resend:hover {
  cursor: pointer;
}
a.resending {
  opacity: 0.3 !important;
}
.icon-wrapper {
  width: 8px;
  height: 10px;
  float: right;
  margin-right: 57px;
}
.confirmationStatus {
  margin-bottom: 4px;
}
.sent {
  font-weight: 500;
  color: #44b358;
  i {
    margin: 0 2px;
    font-weight: 700;
  }
}
.lastSent {
  font-size: 10px;
  color: #666666;
}
.weighted-middot {
  font-size: 2.5em;
  position: relative;
  bottom: -0.1em;
}
</style>
